import { render, staticRenderFns } from "./MarkAsSeenButton.vue?vue&type=template&id=9718ce54&scoped=true"
import script from "./MarkAsSeenButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkAsSeenButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9718ce54",
  null
  
)

export default component.exports